<script lang="ts" setup>
import { computed, PropType } from "vue";
import { PoolDetails } from "@/models/pool-details.model";
import KlereoRadio from "@/shared/components/KlereoRadio.vue";

const props = defineProps({
  out: Object as PropType<PoolDetails["outs"][number]>,
  speedCount: {
    required: true,
    type: Number,
  },
});

const emit = defineEmits(["change"]);

const speeds = computed(() =>
  Array(props.speedCount + 1)
    .fill(0)
    .map((_, i) => i)
);
</script>

<template>
  <div class="flex gap-4">
    <div v-for="speed in speeds" :key="speed">
      <div class="flex gap-1 items-center" @click="emit('change', speed)">
        <KlereoRadio
          class="small"
          name="speed"
          :checked="out?.status === speed"
        />
        <span class="text-sm font-medium">{{
          speed === 0 ? "OFF" : speed
        }}</span>
      </div>
    </div>
  </div>
</template>
